import { connect } from 'react-redux'
import { Navigate } from 'react-router-dom'

const mapStateToProps = ({ auth, account }) => ({
  token: auth.token,
  needChgPwd: auth.needChgPwd,
  permissions: account.permissions,
})

const isReportOnlyRole = permissions =>
  permissions.includes('emailCampaign_view') && !permissions.includes('emailCampaign_create')

const Redirect = ({ token, needChgPwd, permissions }) => {
  if (needChgPwd) {
    return <Navigate to="/reset_password" replace />
  }

  if (!token) {
    return <Navigate to="/login" replace />
  }

  if (permissions === null) {
    return null
  }

  return <Navigate to={isReportOnlyRole(permissions) ? '/user_management' : '/home'} replace />
}

export default connect(mapStateToProps)(Redirect)
